// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IParticipantAccountActivitySummaryRecordDto } from './IParticipantAccountActivitySummaryRecordDto';
import {
    IParticipantAccountActivitySummaryRecordDtoFromJSON,
    IParticipantAccountActivitySummaryRecordDtoFromJSONTyped,
    IParticipantAccountActivitySummaryRecordDtoToJSON,
    IParticipantAccountActivitySummaryRecordDtoToJSONTyped,
} from './IParticipantAccountActivitySummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto
 */
export interface IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IParticipantAccountActivitySummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto
     */
    subsidiary_records?: Array<IParticipantAccountActivitySummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto(value: object): value is IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto {
    return IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IParticipantAccountActivitySummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto {
    return IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoParticipantAccountActivitySummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IParticipantAccountActivitySummaryRecordDtoToJSON)),
    };
}

